// removed by extract-text-webpack-plugin
module.exports = {"socialLoginButton":"AmazonLoginButton__socialLoginButton","amazonButton":"AmazonLoginButton__amazonButton","growDotQello":"AmazonLoginButton__growDotQello","growDotBlue":"AmazonLoginButton__growDotBlue","growDotGolden":"AmazonLoginButton__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonLoginButton/AmazonLoginButton.scss
// module id = 1839
// module chunks = 0